// --- Settings paths (org-scoped) ---
// Return prefix-free paths (e.g. "invoices", "organization").
// For navigation: wrap with useMemberPath().settingsPath()
// For route definitions: use directly

export const INVOICE_SETTINGS_PATH = () => "invoices";
export const ORGANIZATION_PATH = () => "organization";
export const NEW_ORGANIZATION_PATH = () => "new-organization";
export const PROFILE_PATH = () => "profile";

export const STRIPE_ACCOUNT_RETURN_PATH = () =>
  "organization/stripe-create-account-return-link";

export const CUSTOM_FIELDS_LIST_PATH = () => "custom-fields";
export const CUSTOM_FIELD_NEW_FORM = () => "custom-fields/new";
export const CUSTOM_FIELD_UPDATE_FORM = (code: string) =>
  `custom-fields/${code}/edit`;

export const INTEGRATIONS = () => "integrations";
export const SLACK_INTEGRATION_PATH = () => "integrations/slack";
export const STRIPE_INTEGRATION_PATH = () => "integrations/stripe";

export const SERVICES_LIST_PATH = () => "services";
export const SERVICE_DETAIL_PATH = (code: string) => `services/${code}`;

export const TIME_ENTRIES_SETTINGS_PATH = () => "time-entries";

export const REPORT_SUBSCRIPTIONS_PATH = () => "report-subscriptions";

// Legacy paths kept for redirect-only routes; canonical paths now live under
// CUSTOMER_EMAIL_*. Remove once outbound bookmarks have aged out.
export const CLIENT_CONTACT_TYPES_PATH = () => "client-contact-types";
export const SENDER_DOMAIN_PATH = () => "sender-domain";

export const CUSTOMER_EMAIL_PATH = () => "customer-email";
export const CUSTOMER_EMAIL_SENDER_DOMAIN_PATH = () =>
  "customer-email/sender-domain";
export const CUSTOMER_EMAIL_CONTACT_TYPES_PATH = () =>
  "customer-email/contact-types";

export const EXPENSE_CATEGORIES_PATH = () => "expense-categories";

export const EXPENSE_BUDGETS_PATH = () => "expense-budgets";

export const EXPENSES_INBOUND_PATH = () => "expenses-inbound";

export const BILLING_PATH = () => "billing";
export const BILLING_PLANS_PATH = () => "billing/plans";
export const BILLING_SETTINGS_PATH = () => "billing/settings";
export const BILLING_ADD_ONS_PATH = () => "billing/add-ons";

export const ACTIVITY_PATH = () => "activity";

export const TEAM_MEMBER_DETAILS_PATH = (code: string) =>
  `team-members/${code}`;
